import React, {Component} from 'react';
import ReportSoggettiView from './ReportSoggettiView'

class ReportSoggettiViewSwitcher extends Component {
    constructor(props) {
        super(props);
        this.state = {
            activeTab: 0
        };
    }

    changeTab(tabnum){
        this.setState({activeTab: tabnum})
    }

    render() {
        let currView = null;
        if (this.state.activeTab === 0){
            currView = <ReportSoggettiView {...this.props} />
        }
        else
        {
            currView = <ReportSoggettiView {...this.props} compact={true} />
        }

        return <div>
            <div className="ui top attached tabular menu">
                <a className={this.state.activeTab === 0 ? "item active": "item"} onClick={()=>(this.changeTab(0))}>Elenco completo</a>
                <a className={this.state.activeTab === 1 ? "item active": "item"} onClick={()=>(this.changeTab(1))}>Elenco compatto</a>
            </div>
            <div className="ui bottom attached tab segment active no-print">
                {currView}
            </div>
        </div>
    }
}



export default ReportSoggettiViewSwitcher;




/** WEBPACK FOOTER **
 ** ./src/components/report/ReportSoggettiViewSwitcher.js
 **/